// extracted by mini-css-extract-plugin
export default {"text":"SmsCampaigns_text__F-aIV","recipients":"SmsCampaigns_recipients__BY4vr","recipientStat":"SmsCampaigns_recipientStat__+DkoR"};